import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, Form, Modal } from 'semantic-ui-react';
import { TranslationComponent } from './TranslationComponent';
import { Field, Formik, FormikValues } from 'formik';
import { useTranslation } from 'react-i18next';
import { IUser } from '@relab/alstom-ptw-shared';
import { userEditAction } from '../redux/actions';
import moment from 'moment';

interface LangModalProps {
  language: string;
  user: IUser;
  userEditAction: typeof userEditAction;
}

const PLangEditModal: React.FC<LangModalProps> = ({ language, user, userEditAction }) => {
  const { t, i18n } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = () => setModalOpen(true);

  const handleModalClose = () => setModalOpen(false);

  const handleSubmit = (values: FormikValues) => {
    const { language } = values;

    i18n
      .changeLanguage(language)
      .then(() => {
        moment.locale(language);
        handleModalClose();
      })
      .catch((e) => {
        console.error(e);
      });

    userEditAction({
      ...user,
      preferredLanguage: values.language,
    });
  };

  const availableLangs = useMemo(
    () =>
      Object.keys(i18n.options.resources).map((langKey) => {
        return (
          <option key={langKey} value={langKey}>
            {langKey.toUpperCase()}
          </option>
        );
      }),
    [i18n.options.resources]
  );

  return (
    <Formik
      initialValues={{ language: language }}
      onSubmit={(values) => {
        handleSubmit(values);
      }}
    >
      {({ handleSubmit }) => (
        <Modal
          trigger={<Dropdown.Item text={t('Translate')} onClick={handleModalOpen} />}
          open={modalOpen}
          onClose={handleModalClose}
          closeOnDimmerClick={false}
        >
          <Modal.Header>
            <TranslationComponent stringKey={'Translate'} />
          </Modal.Header>
          <Modal.Content>
            <Form id="editTranslationLang" size="large" error onSubmit={handleSubmit}>
              <Modal.Description>
                <Field as="select" name="language">
                  {availableLangs}
                </Field>
              </Modal.Description>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={handleModalClose}>
              <TranslationComponent stringKey={'Cancel'} />
            </Button>
            <Button primary form="editTranslationLang" type="submit">
              <TranslationComponent stringKey={'Confirm'} />
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

export const LangEditModal = connect(null, { userEditAction })(PLangEditModal);
